export enum LeadOrigin {
  MANUAL = "MANUAL",
  WEBSITE = "WEBSITE",
  LINKEDIN = "LINKEDIN",
  INSTAGRAM = "INSTAGRAM",
  FACEBOOK = "FACEBOOK",
  GOOGLE_ADS = "GOOGLE_ADS",
  REFERRAL = "REFERRAL",
}

export enum LeadStatus {
  IN_CONTACT = "IN_CONTACT",
  DEMO_SCHEDULED = "DEMO_SCHEDULED",
  IN_NEGOTIATION = "IN_NEGOTIATION",
  CONVERTED = "CONVERTED",
  LOST = "LOST",
}

export enum LeadSortField {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  NAME = "name",
}

export type LeadObservationAuthorType = "USER" | "SYSTEM";

export const LeadStatusLabels: Record<LeadStatus, string> = {
  [LeadStatus.IN_CONTACT]: "Em contato",
  [LeadStatus.DEMO_SCHEDULED]: "Demonstração agendada",
  [LeadStatus.IN_NEGOTIATION]: "Em negociação",
  [LeadStatus.CONVERTED]: "Convertido",
  [LeadStatus.LOST]: "Perdido",
};

export const LeadOriginLabels: Record<LeadOrigin, string> = {
  [LeadOrigin.MANUAL]: "Manual",
  [LeadOrigin.WEBSITE]: "Site",
  [LeadOrigin.LINKEDIN]: "LinkedIn",
  [LeadOrigin.INSTAGRAM]: "Instagram",
  [LeadOrigin.FACEBOOK]: "Facebook",
  [LeadOrigin.GOOGLE_ADS]: "Google Ads",
  [LeadOrigin.REFERRAL]: "Indicação",
};

export const LEAD_STATUS_OPTIONS = Object.values(LeadStatus).map((status) => ({
  value: status,
  label: LeadStatusLabels[status],
}));

// Removed WEBSITE value since that is for system creation only
export const LEAD_ORIGIN_FORM_OPTIONS = Object.values(LeadOrigin)
  .filter((origin) => origin !== LeadOrigin.WEBSITE)
  .map((origin) => ({
    value: origin,
    label: LeadOriginLabels[origin],
  }));

export const LEAD_ORIGIN_OPTIONS = Object.values(LeadOrigin).map((origin) => ({
  value: origin,
  label: LeadOriginLabels[origin],
}));

export const LEAD_SEGMENT_OPTIONS = ["Setor Público", "Saúde", "Educação", "Varejo & Franquias", "Indústrias", "Condomínios", "Outro"].map(
  (segment) => ({
    value: segment,
    label: segment,
  }),
);

export const LEAD_SORT_OPTIONS = [
  { field: LeadSortField.CREATED_AT, label: "Data de recebimento" },
  { field: LeadSortField.UPDATED_AT, label: "Última atualização" },
  { field: LeadSortField.NAME, label: "Nome" },
];
